var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"_rightPan"}},[_c('div',{staticClass:"top"},[_c('span',[_vm._v(_vm._s(_vm.hello))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.info))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }